import { render, staticRenderFns } from "./HorizontalRadio.vue?vue&type=template&id=d2195228&"
import script from "./HorizontalRadio.vue?vue&type=script&lang=js&"
export * from "./HorizontalRadio.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalRadio.vue?vue&type=style&index=0&id=d2195228&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports